import { Swiper, Navigation, EffectFade } from 'swiper'

Swiper.use([Navigation, EffectFade])

const $slider = document.querySelector('.blog-post-slider')

const fn = {
  init: () => {
    if ($slider.querySelectorAll('.swiper-slide').length < 2) {
      return
    }

    const swiper = new Swiper($slider.querySelector('.swiper-container'), {
      autoHeight: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        prevEl: $slider.querySelector('.slider-prev'),
        nextEl: $slider.querySelector('.slider-next'),
      },
    })

    swiper.on('slideChange', function () {
      $slider.querySelector('.swiper-slide-counter span').textContent =
        this.activeIndex + 1
    })
  },
}

export default {
  can: () => $slider,
  run: fn.init,
}
